import React from 'react';
import { Link } from 'react-router-dom';

/**
 * TrueNooch wordmark — fixed top-left, links back to the home page (#home).
 * Rendered by MarketingSite on every page EXCEPT home (home's hero already
 * carries the brand). Inline SVG so it stays crisp at any size and needs no
 * asset file. Type matches the site: Instrument Serif, cream-to-gold gradient,
 * with a small gold trademark mark.
 */
export function BrandLogo() {
  return (
    <Link className="nav-logo" to="/" aria-label="TrueNooch — home">
      <svg
        className="nav-logo-svg"
        viewBox="0 0 258 40"
        role="img"
        aria-hidden="true"
        focusable="false"
      >
        <defs>
          <linearGradient id="tn-logo-grad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#F5F0E8" />
            <stop offset="55%" stopColor="#E8CF8C" />
            <stop offset="100%" stopColor="#B8860B" />
          </linearGradient>
        </defs>
        <text
          x="0"
          y="30"
          fontFamily="'Instrument Serif', Georgia, serif"
          fontSize="34"
          fill="url(#tn-logo-grad)"
        >
          TrueNooch<tspan dx="3" dy="-13" fontSize="18" fill="#B8860B">™</tspan>
        </text>
      </svg>
    </Link>
  );
}
